import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { ifProd } from 'Utils/env';
import { decode } from 'js-base64';
import PropTypes from 'prop-types';
import { SessionReadyProvider } from 'Services/SessionReady/SessionReady';

const Auth0ProviderWithHistory = ({ children }) => {
  const domain = ifProd(process.env.AUTH0_DOMAIN_PROD, process.env.AUTH0_DOMAIN);
  const clientId = ifProd(process.env.AUTH0_CLIENT_ID_PROD, process.env.AUTH0_CLIENT_ID);
  const loginHint = localStorage.getItem('hintId') ? decode(localStorage.getItem('hintId')) : '';

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience: 'kueski-customer',
        login_hint: loginHint,
        redirect_uri: window.location.origin,
        scope: 'openid profile email offline_access',
      }}
      cacheLocation="localstorage"
      useRefreshTokens
      onRedirectCallback={(state) => {
        if (state?.returnTo) {
          window.location.assign(state.returnTo);
        }
      }}
    >
      <SessionReadyProvider>
        {children}
      </SessionReadyProvider>
    </Auth0Provider>
  );
};

Auth0ProviderWithHistory.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Auth0ProviderWithHistory;
